import { useEffect, useRef } from 'react';
import useAuth from './useAuth';

export default function useInactivityTimer(
  timeoutMinutes = 15,
  isActivityTimerEnabled: boolean = false
) {
  const { logout, isLoggedIn } = useAuth();
  const timeoutRef = useRef<number | null>(null);

  // Convert min to ms
  const timeoutMs = timeoutMinutes * 60 * 1000;

  const resetTimer = () => {
    // Clear existing timeout
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }

    // Set new timeout
    timeoutRef.current = window.setTimeout(() => {
      logout();
    }, timeoutMs);
  };

  useEffect(() => {
    if (isActivityTimerEnabled || !isLoggedIn) return;

    const activityEvents = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'keydown'
    ];

    // First, Set initial timeout
    resetTimer();

    const handleUserActivity = () => resetTimer();

    // Add all event listeners
    activityEvents.forEach(event => {
      document.addEventListener(event, handleUserActivity);
    });

    return () => {
      activityEvents.forEach(event => {
        document.removeEventListener(event, handleUserActivity);
      });

      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [isActivityTimerEnabled, isLoggedIn, timeoutMs, logout]);
}
